import { TransactionType } from "../../extract/extract.model";

export class Detail {
	transactionId: number;
	code: number;
	debitDate: string;
	dateTimeTransaction: any;
	number: number;
	value: number;
	complement: string;
	autentication: string;
	favName: string;
	favCpfCnpj: string;
	favBank: number;
	favBankDescription: string;
	favAgency: number;
	favNumberAccount: string;
	favTypeAccount: string;
	transactionType: TransactionType;
	transferEmitBankDescription: string;
	transferEmitAgency: number;
	transferEmitNumberAccount: any;
	transferEmitCpfCnpj: string;
	finalitySPB: number;
	historic: string;
	finalityTes: number;
	finalityCompe: number;
	codeBar: string;
	dueDate: string;
	assignorName: string;
	assignorCpfCnpj: string;
	transferEmitName: string;
	endToEndId: string;
	transactionCode: string;

	hasFirstRow = true;
	hasSecondRow = true;
	hasThirdRow = true;
	hasFourthRow = true;
	hasFifthRow = true;
	isSecuritie = false;

	payerName: string;
	payerCpfCnpj: string;
	payerAgency: number;
	payerAccount: string;

	securitieRebateValue: number;
	taxValue: number;
	fineValue: number;
	chargesValue: number;
	discountValue: number;
	nominalValue: number;

	receiptsTitle: string;
	receiptsSubtitle: string;
	nameAgreement: string;

	complementTransactionOrig: string;
	valueTransactionOrig: string;
	dateTimeTransactionOrig: string;

	cellphoneNumber: string;
	cellphoneOperator: string;

	constructor() {
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/models/details.ts